import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { executeimport } from "../../../../controllers/import/index";

export const EXECUTE_IMPORT_XLSX_DOCUMENT_REQUEST = 'EXECUTE_IMPORT_XLSX_DOCUMENT_REQUEST';
export const EXECUTE_IMPORT_XLSX_DOCUMENT_SUCCESS = 'EXECUTE_IMPORT_XLSX_DOCUMENT_SUCCESS';
export const EXECUTE_IMPORT_XLSX_DOCUMENT_FAILURE = 'EXECUTE_IMPORT_XLSX_DOCUMENT_FAILURE';
export const EXECUTE_IMPORT_DEFAULT = 'EXECUTE_IMPORT_DEFAULT';

interface ActionDefault<T> {
    type : string,
    payload  : T
}

interface ActionPagination<T> {
    type : string,
    payload  : T
}

const executeimportXlsxDocumentRequest = () => {
    return {
        type: EXECUTE_IMPORT_XLSX_DOCUMENT_REQUEST,
    };
};

const executeimportXlsxDocumentSuccess = (data: any):ActionPagination<Result<any>> => {
    return {
        type: EXECUTE_IMPORT_XLSX_DOCUMENT_SUCCESS,
        payload :data
    };
};

const executeimportXlsxDocumentFailure = (error: any) => {
    return {
        type: EXECUTE_IMPORT_XLSX_DOCUMENT_FAILURE,
        payload: error,
    };
};

export const executeimportDefault = () => {
    return {
        type: EXECUTE_IMPORT_DEFAULT,
    };
};

export const ExecuteImport = (fileId:string)=>  {
    return async (dispatch: Dispatch<AnyAction>) => {
         dispatch(executeimportXlsxDocumentRequest());
         try {
            const response = await executeimport(fileId);
            dispatch(executeimportXlsxDocumentSuccess(response.data));
         } catch (error:any) {
             dispatch(executeimportXlsxDocumentFailure(error.message));
         }
     };
 };
